import { FC, useState } from 'react';
import { Field, FieldAttributes, FieldProps } from 'formik';
import styled from 'styled-components';

import { AvatarPessoaPesquisavel } from '../AvatarPessoa/AvatarPessoaPesquisavel';
import { Botao } from '../Botao/Botao';

import { FiSearch } from "react-icons/fi";
import { SRText } from '../ScreenReaderText/ScreenReaderText';
import { BuscaServidoresModal } from 'view/section/BuscaServidoresSection/BuscaServidoresModal';
import { LoadingTexto } from '../Tipografia/Texto';
import { Servidor } from 'model/ufc/Servidor';
import { useCampoFormularioProps } from 'service/restricao/useCampoFormularioProps/useCampoFormularioProps';
import { Avatar } from '../Avatar/Avatar';
import Spinner from '@atlaskit/spinner';
import { LimparBotaoPequeno } from '../Botao/LimparBotaoPequeno';


interface ServidorFielsProps extends FieldAttributes<any> {
  idInstitucional?: string;
  name: string;
}

export const ServidorField: FC<ServidorFielsProps> = ({idInstitucional, className, ...props}) => {
  const restricaoProps = useCampoFormularioProps(props.name, undefined);

  if (restricaoProps.hidden)
    return <></>

  const Tag = restricaoProps.readOnly
    ? ServidorVisualizacaoField
    : ServidorEdicaoField;
  
  return <Field {...props}>
    {(formikProps: FieldProps) => {
      const onServidorSelected = (servidor?: Servidor) => formikProps.form.setFieldValue(formikProps.field.name, servidor?.idInstitucional);
      const idInstitucional = formikProps.field.value;

      return <Container className={`${className ?? ''}`}>
        <Tag
          idInstitucional={idInstitucional}
          onBlur={formikProps.field.onBlur}
          name={props.name}
          onServidorSelected={onServidorSelected}
          isSubmitting={formikProps.form.isSubmitting} />
      </Container>
    }}
  </Field>
}


interface ServidorExibicaoProps extends FieldAttributes<any> {
  name: string;
  idInstitucional?: string;
  onServidorSelected: (servidor?: Servidor) => void;
  isSubmitting: boolean;
}

const ServidorVisualizacaoField: FC<ServidorExibicaoProps> = ({idInstitucional, name}) => {
  const restricaoProps = useCampoFormularioProps(name, undefined);
  const carregando = restricaoProps.loading;
  const carregandoSomenteLeitura = restricaoProps.loading && restricaoProps.readOnly;

  if (carregando && idInstitucional === undefined) {
    return <>
      <Avatar loading={true} /> 
      <LoadingTexto width={120} />
      <Spinner />
    </>
  }

  return idInstitucional
    ? <><AvatarPessoaPesquisavel ocultarTooltip={true} idInstitucional={idInstitucional} exibirNome={true} />{ carregandoSomenteLeitura && <Spinner />}</>
    : <span>A definir</span>;
}

const ServidorEdicaoField: FC<ServidorExibicaoProps> = ({idInstitucional, onBlur, onServidorSelected, name, isSubmitting}) => {
  const restricaoProps = useCampoFormularioProps(name, undefined);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const fecharModal = () => setModalIsOpen(false);
  const abrirModal = () => setModalIsOpen(true);

  const limparServidor = () => onServidorSelected(undefined);
  const onSelected = (servidor: Servidor) => {
    onServidorSelected(servidor);
    fecharModal();
  }

  const limpavel = restricaoProps.clearable && idInstitucional;
  const disabled = restricaoProps.disabled || isSubmitting;
  return <>
    <ServidorVisualizacaoField idInstitucional={idInstitucional} onServidorSelected={onServidorSelected} name={name} isSubmitting={isSubmitting} />

    {limpavel && <LimparBotaoPequeno onClick={limparServidor} />}
    <Botao onClick={abrirModal} type="button" onBlur={onBlur} name={name} disabled={disabled}>
      <FiSearch aria-hidden={true} /><SRText>Buscar servidor (será aberto um modal)</SRText>
    </Botao>
    
    <BuscaServidoresModal isAberto={modalIsOpen} onServidorSelected={onSelected} onClose={fecharModal} />
  </>;
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 4px;
`;
